import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React from 'react';

import { SelectClassifierMenuViewModel } from './select-classifier-menu.vm';
import {
  ClassificationLevelSelectContainer,
  HighestClassificationLevelLabel,
  HighestClassificationLevelSelect,
} from './style';

const SelectClassifierMenu: React.FC = () => {
  const vm = useViewModel(SelectClassifierMenuViewModel);
  return (
    <ClassificationLevelSelectContainer>
      <HighestClassificationLevelLabel htmlFor="highestClassifier">
        {vm.highestClassificationLevelName}
      </HighestClassificationLevelLabel>

      <HighestClassificationLevelSelect
        name="highestClassifier"
        id="highestClassifier"
        defaultValue={vm.selectedOption.guid}
        key={vm.selectedOption.guid}
        onChange={async (e) => await vm.selectClassifier(e.target.value)}
      >
        {vm.highestClassificationLevel.map((classifier, index) => (
          <option key={index} value={classifier.guid}>
            {classifier.name}
          </option>
        ))}
      </HighestClassificationLevelSelect>
    </ClassificationLevelSelectContainer>
  );
};

export default observer(SelectClassifierMenu);
